module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "_1-CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "leading-139-5 CharOverride-10"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("or Claire.")])]), _vm._v(" "), _c('p', {
    staticClass: "DED_Dedication_text"
  }, [_vm._v("And in memory of Banaz Mahmod "), _c('br'), _vm._v("and Rahmat Sulemani.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25c0a719","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBookVR02454.vue
// module id = 75
// module chunks = 0